import React from 'react';
import styles from '../../styles/GruposStyles/PantallaDeGrupos.module.css';

const StatusBadge = ({ status, type = 'estado' }) => {
  const getStatusConfig = () => {
    switch (status.toLowerCase()) {
      case 'abierto':
        return {
          className: type === 'estado' ? styles.estadoAbierto : styles.estadoAbierto2,
          containerClass: type === 'estado' ? styles.div30 : styles.div37,
          textClass: styles.abierto
        };
      case 'cerrado':
        return {
          className: type === 'estado' ? styles.estadoCerrado : styles.estadoCerrado2,
          containerClass: type === 'estado' ? styles.div35 : styles.div49,
          textClass: styles.cerrado
        };
      case 'activo':
        return {
          className: styles.estadoActivo,
          containerClass: styles.div40,
          textClass: styles.activo
        };
      case 'inactivo':
        return {
          className: styles.estadoInactivo,
          containerClass: styles.div43,
          textClass: styles.inactivo
        };
      case 'tentativo':
        return {
          className: styles.estadoTentativo,
          containerClass: styles.div46,
          textClass: styles.tentativo
        };
      case 'cancelado':
        return {
          className: styles.estadoCancelado,
          containerClass: styles.div50,
          textClass: styles.cancelado
        };
      default:
        return {
          className: styles.estadoAbierto,
          containerClass: styles.div30,
          textClass: styles.abierto
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className={config.className}>
      <div className={config.containerClass}>
        <div className={config.textClass}>
          {status.toUpperCase()}
        </div>
      </div>
    </div>
  );
};

export default StatusBadge;
